import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { RoleRelationsComponent } from '@fi-app/role/role-relations/role-relations.component';
import { ExtendedRoleRightService } from '../services/extended-role-right.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { AppTextService } from '@fi-shared/app-text';
import { FiRoleStateResolveAllRoles } from '@fi-app/role/states/resolve/all-roles';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiRoleRelationsState: Ng2StateDeclaration = {
    name: FiStateNames.Role.RoleRelations,
    url: '/:Id/Relations',
    params: {
        shareExistingContent: null,
    },
    views: {
        '@': {
            component: RoleRelationsComponent,
        },
    },
    resolve: {
        roleRelations: [
            FiStateService,
            ExtendedRoleRightService,
            '$transition$',
            FiRoleRelationsStateResolve_roleRelations,
        ],
        allRoles: FiRoleStateResolveAllRoles,
        shareExistingContent: [FiStateService, '$transition$', FiRoleRelationsStateResolve_shareExistingContent],
        pageTitle: [PageTitleService, AppTextService, 'roleRelations', FiRoleRelationsStateResolve_pageTitle],
    },
};

export function FiRoleRelationsStateResolve_roleRelations(
    fiStateService: FiStateService,
    extendedRoleRightService: ExtendedRoleRightService,
    $transition$,
) {
    return extendedRoleRightService.getRoleRelations(fiStateService.getParams($transition$).Id);
}

export function FiRoleRelationsStateResolve_shareExistingContent(fiStateService: FiStateService, $transition$) {
    return fiStateService.getParams($transition$).shareExistingContent;
}

export function FiRoleRelationsStateResolve_pageTitle(
    ccmPageTitle: PageTitleService,
    appTextService: AppTextService,
    roleRelations,
) {
    return ccmPageTitle.setTitle(appTextService.get('role.relations') + ': ' + roleRelations.RoleName);
}
